(function () {
  // 强制调试器卡死（防破解）
  setInterval(() => { debugger }, 100)
})()
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import VueAnimateNumber from 'vue-animate-number'
import 'animate.css'
import 'default-passive-events'
import store from './store'
import apiFun from './request/api'
import preventReClick from './assets/js/preventRepeatClick'
// import wow from 'wowjs'
import { WOW } from 'wowjs'
Vue.use(preventReClick)
Vue.prototype.$apiFun = apiFun // 请求接口api
Vue.use(VueAnimateNumber)
Vue.prototype.$bus = new Vue()
// Vue.prototype.$wow = wow
Vue.prototype.$wow = new WOW({
  live: false
})
Vue.config.productionTip = false
// Vue.prototype.setSessionItem = function (key, newVal) {
//   // 创建 StorageEvent 事件
//   const newStorageEvent = document.createEvent('StorageEvent')
//   const storage = {
//     setItem: function (k, val) {
//       sessionStorage.setItem(k, val)
//       // 初始化 StorageEvent 事件
//       newStorageEvent.initStorageEvent(
//         'setItem', // 事件别名
//         false,
//         false,
//         k,
//         null,
//         val,
//         null,
//         null
//       )
//       // 派发事件
//       window.dispatchEvent(newStorageEvent)
//     }
//   }
//   return storage.setItem(key, newVal)
// }
Vue.prototype.setSessionItem = function (key, newVal) {
  // 1. 先存值
  sessionStorage.setItem(key, newVal)

  // 2. ✅ 新版标准写法：替代废弃的 createEvent + initStorageEvent
  const newStorageEvent = new StorageEvent('storage', {
    key: key,
    oldValue: null,
    newValue: newVal,
    storageArea: sessionStorage,
    bubbles: false,
    cancelable: false
  })

  // 3. 派发事件
  window.dispatchEvent(newStorageEvent)
}

// 设置路由拦截

router.beforeEach((to, from, next) => {
  if (window.location.hostname.includes('www.kuainiaoip.com') && to.path !== '/') {
    window.location.href = 'https://kuainiaoip.com'
    return// 跳转后不再执行其他路由逻辑
  }
  // 判断是否需要登录验证
  const token = window.sessionStorage.getItem('token')
  // /如果页面需要拦截
  if (to.matched.some(record => record.meta.requireAuth)) {
    // 存在用户信息则不拦截
    if (token) {
      next()
    } else {
      // 没有登录则提示并重定向
      Vue.prototype.$message.error('请先进行登录操作！')
      next('/')
    }
  // 不需要拦截
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
